<template>
  <div class="no_result">
    <div class="primary">
      <!-- <p>没有搜索结果</p>-->
<!--      <p class="title">没有找到相关宝贝</p>-->
      <p class="title">商品加载中，请稍等</p>
      <Button class="my_btn mr_20"
              type="primary"
              ghost
              @click="goBack">返回</Button>
      <Button class="my_btn"
              type="primary"
              @click="goHome">首页</Button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  methods: {
    goBack () {
      this.$router.go(-1);//返回上一层
    },
    goHome () {
      this.$router.push('/index')
    }
  }
}
</script>

<style lang="less" scoped>
.no_result {
  text-align: center;
  font-size: 24px;
  > div {
    margin: 100px auto;
    width: 220px;
    text-align: left;
  }
}
.title {
  font-size: 24px;
  margin-bottom: 20px;
}
.my_btn {
  width: 100px;
}
</style>
